<template>
  <div class="header" :style="{background: background}">
    <van-row type="flex">
        <div class="back" v-if="isBack" @click="clickBack">
          <van-icon name="arrow-left" v-if="isBack" :style="{color:iconColor}" />
        </div>
      <van-col span="24" class="center title" :style="{color:color}">
       {{title}}
      </van-col>
      <!-- <van-col span="6">span: 6</van-col> -->
    </van-row>
  </div>
</template>

<script>
if(process.env.NODE_ENV=="production"){
  document.write(unescape("%3Cspan id='cnzz_stat_icon_1281099994'%3E%3C/span%3E%3Cscript src='https://v1.cnzz.com/z_stat.php%3Fid%3D1281099994' type='text/javascript'%3E%3C/script%3E"));
}else{
  document.write(unescape("%3Cspan id='cnzz_stat_icon_1281103964'%3E%3C/span%3E%3Cscript src='https://s4.cnzz.com/z_stat.php%3Fid%3D1281103964' type='text/javascript'%3E%3C/script%3E"));
}

import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'Headers',
  props: {
    title: {
      type: String,
      default: ''
    },
    background: {
      type: String,
      default: '#F9FBFC'
    },
    color: {
      type: String,
      default: '#000000'
    },
    iconColor: {
      type: String,
      default: 'rgb(0, 0, 0)'
    },
    isBack: {
      type: Boolean,
      default: true
    },
  },
  computed: { ...mapGetters({ pageData: 'pageData'}) },
  data () {
    return {
      
    }
  },
  methods:{
    clickBack() {
      if(!!this.$parent&&this.$parent.back) {
        this.$parent.back();
      }
      //this.$router.go(-1)
      window.history.back()
       // window.close();     
    //  try{
    //     this.$router.back();
    //    var _this = this;
    //     setTimeout(() => {
    //     let path = getHash().slice(1);
    //       if(path.indexOf(_this.$route.path) == -1){
    //           _this.$router.replace(path);
    //       }

    //   }, 1);
    //  }catch(err){
    //     console.log(err);
    //  }

    //   function getHash(){
    //     return window.location.hash;
    //   }

      // let list = this.pageData.historyList
      // let path = this.pageData.historyList[list.length-2]
      // list.splice(list.length-2)
      // this.$store.commit('newPageData', { key: 'historyList', data: list})
      // this.$util.goPage(path)
    }
  }
}
</script>

<!-- Add "scoped" attribute to CSS to this component only -->
<style lang="less" scope>

.header {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 99;
  height: 40px;
  line-height: 40px;
  .van-icon-arrow-left {
    font-size:20px;
    line-height: 40px;
  }

  .title {
    font-size:14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 40px;
  }
}
.back {
  position: absolute;
  width: 60px;
  top: 0;
  left: 0;
  height: 100%;
  padding-left: 10px;
  z-index: 996;
}
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue